import { Injectable, inject } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../../environments/environment'
import { Observable } from 'rxjs'
import { ItemProductionRoute, WorkItem } from './work-item'
import { WorkItemSchedule } from './work-item-schedule'
import { Filter, HttpParamsBuilder } from '@elderbyte/ngx-starter'
import { WorkItemFilter } from './work-item.service'

export class RouteEvalOptionsBuilder {
  public static ignoreAll(): Filter[] {
    return [this.ignoreStrategy(true), this.ignoreConstraints(true), this.ignoreWorkHours(true)]
  }

  public static ignoreConstraints(ignoreConstraints: boolean): Filter {
    return new Filter('ignoreConstraints', ignoreConstraints + '')
  }

  public static ignoreStrategy(ignoreStrategy: boolean): Filter {
    return new Filter('ignoreStrategy', ignoreStrategy + '')
  }

  public static ignoreWorkHours(ignoreWorkHours: boolean): Filter {
    return new Filter('ignoreWorkHours', ignoreWorkHours + '')
  }
}

@Injectable({
  providedIn: 'root',
})
export class WorkItemSchedulerService {
  private readonly http = inject(HttpClient)

  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly logger = LoggerFactory.getLogger(this.constructor.name)

  private readonly workItemAggregatedSchedulerApi = `${environment.apiPath}/work-item-scheduler/aggregated`

  /***************************************************************************
   *                                                                         *
   * GET Aggregated Routes                                                   *
   *                                                                         *
   **************************************************************************/

  public findAggregatedRoutesForAll(
    items: WorkItem[],
    routeEvalOptions: Filter[]
  ): Observable<WorkItemSchedule[]> {
    return this.http.get<WorkItemSchedule[]>(this.workItemAggregatedSchedulerApi, {
      params: HttpParamsBuilder.start()
        .appendFilter(this.getItemFilter(items))
        .appendFilters(routeEvalOptions)
        .build(),
    })
  }

  /***************************************************************************
   *                                                                         *
   * Assign Aggregated Route                                                 *
   *                                                                         *
   **************************************************************************/

  public assignAggregatedRouteForAll(
    items: WorkItem[],
    route: WorkItemSchedule
  ): Observable<Map<string, ItemProductionRoute>> {
    return this.http.put<Map<string, ItemProductionRoute>>(
      this.workItemAggregatedSchedulerApi,
      route,
      {
        params: HttpParamsBuilder.start().appendFilter(this.getItemFilter(items)).build(),
      }
    )
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/

  private getItemFilter(items: WorkItem[]): Filter {
    return WorkItemFilter.ids(items.map((i) => i.id))
  }
}
